module.exports = __webpack_public_path__ + "static/media/argoscholar_logo_light.a7447f19.svg";